import React, {useState, useEffect} from 'react';
import {ContenedorFiltros,Contenedor, Formulario,Input,Btn, Icono, ContenedorDoble } from '../elementos/ElementosDeFormularioCreaViaje';
import Boton from './../elementos/Boton';
import {ReactComponent as IconoPlus} from './../imagenes/plus.svg';
import {db} from '../firebase/firebaseConfig';
import { ref, orderByChild, equalTo,query, onValue, update, remove, limitToFirst } from "firebase/database";
import {ContenedorNuevaDireccion,ContenedorSubtituloPequeño, ContenedorOrigen, ContenedorDestino,ContenedorSubtitulo, Subtitulo, ContenedorBoton,Lista,
    Descripcion,
    ContenedorBotonesl,
    BotonAccion,
    ElementoListad,ContenedorInputconLabel} from './../elementos/ElementosDeFormularioCreaViaje';
import SelectClientes from './SelectClientes';
import "react-toggle/style.css"
import Swal from 'sweetalert2';
import SelectEstadoPasajero from './SelectEstadoPasajero';
import SelectSolicitaTraslado from './SelectSolicitaTraslado';
import SelectTipoPasajero from './SelectTipoPasajero';


const FormularioEditaPasajero = ({}) => {

    const [telefonopb, Cambiartelefonopb] = useState('');
    const [nombrep, Cambiarnombrep] = useState('');
    const [telefonop, Cambiartelefonop] = useState('');
    const [empresap, Cambiarempresap] = useState('');
    const [rfcp, CambiarRfcp] = useState('');
    const [Idp, CambiarIdp] = useState('');
    const [formulariopasajero, cambiarformulariopasajero] = useState(true);
    const [formulariopasajerodo, cambiarformulariopasajeroo] = useState(true);
    const [direccionlista, Cambiardireccionlista] = useState([]);
    const [varnum, cambiarVarnum] = useState('');
    const [estadop, cambiarEstadop] = useState('');
    const [solicitat, cambiarSolicitat] = useState('');
    const [Tipop, CambiarTipop] = useState('');
    useEffect (()=>{    
        Cambiarnombrep ('');
        Cambiartelefonop ('');
        Cambiarempresap ('');
        CambiarRfcp('');
        CambiarTipop('');
        Cambiardireccionlista([]);
        //Agrega prefijo a numero de busqueda    
            if (telefonopb.substring(0, 1) === "1"){
                cambiarVarnum('5491'+(telefonopb))
            }else{
                cambiarVarnum('56'+(telefonopb))
            }
    },[telefonopb]);

	const handleChange = (e) => {
		if(e.target.name === 'telefonopb'){Cambiartelefonopb(e.target.value);} 
        else if (e.target.name === 'nombre'){Cambiarnombrep(e.target.value);}
        else if (e.target.name === 'rfc'){CambiarRfcp(e.target.value);} 
    }
// Al hacer click en editar pasajero.  	
    const handleSubmit = async (e) => {
        e.preventDefault();
		if(nombrep === '' || nombrep === undefined ){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa nombre de pasajero',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(telefonop === '' || telefonop === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor busca pasajero por teléfono',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(empresap === 'Seleccione Cliente' || empresap === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona cliente',
                icon: 'error',
                timer:2000
                })

			return;
		}

        if(Tipop === '' || Tipop === undefined){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor selecciona Tipo de Pasajero',
                icon: 'error',
                timer:2000
                })

			return;
		}

// Accion de Editar Pasajero   
            if (estadop === '' || estadop === undefined ){
            await update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+Idp),
            {   nombre: nombrep,
                //estado: estadop,
                empresa: empresap,
                rfc: rfcp,
                tipo: Tipop
                //solicita_traslado: solicitat
               // direcciones : 
            })}else{

                await update(ref(db,'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/'+Idp),
                {   nombre: nombrep,
                    estado: estadop,
                    empresa: empresap,
                    rfc: rfcp,
                    solicita_traslado: solicitat,
                    tipo: Tipop
                   // direcciones : 
                })
                
            }
        
            Swal.fire({
                title: 'Aviso de edicion',
                text: 'Los Datos del pasajero fueron editados',
                icon: 'success',
                timer:2000
                })
                cambiarformulariopasajero (true);
                cambiarformulariopasajeroo(true);
                Cambiartelefonopb('');
                Cambiarnombrep ('');
                Cambiartelefonop ('');
                Cambiarempresap ('');
                CambiarTipop('');
                CambiarRfcp('');
                CambiarIdp('');
                cambiarEstadop('');
                cambiarSolicitat('');
    }   

// Al hacer click en buscar numero telefonico de pasajero.    
    const onClicktelefonopb = async (e) => {
        e.preventDefault();
        Cambiarnombrep ('');
        Cambiartelefonop ('');
        Cambiarempresap ('');
        CambiarRfcp('');
        CambiarTipop('');
        CambiarIdp('');
        cambiarEstadop('');
        cambiarSolicitat('');
// Comprobamos del lado del cliente que el campo de numero tiene contenido.
        if(telefonopb === ''){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por Favor ingresa un número telefónico para buscar al pasajero',
                icon: 'error',
                timer:2000
                })

			return;
		}
// Comprobamos del lado del cliente que el telefono sea valido.
		const expresionRegular = /^[0-9]{9}$/g;
		if( !expresionRegular.test(telefonopb) ){
            Swal.fire({
                title: 'Complete Información',
                text: 'Por favor ingresa teléfono con 9 dígitos sin incluir el +56',
                icon: 'error',
                timer:2000
                })
			return;
		}

        if(telefonopb.length === 9) {
            
                       
            const consulta = query (ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros'), orderByChild('telefono'), equalTo(Number(varnum)), limitToFirst(1));
            
            onValue (consulta, (snapshot) => {
                   let records = [];
                   snapshot.forEach((childSnapshot) => {
                   const childKey = childSnapshot.key;
                   const childData = childSnapshot.val();
                   records.push({...childData,id: childKey}) 
                   });

// accion si cliente existe                   
                        if (records.length > 0) {
                        CambiarIdp(records[0].id);
                        Cambiarnombrep (records[0].nombre);
                        Cambiartelefonop (records[0].telefono);
                        Cambiarempresap (records[0].empresa);
                        CambiarTipop(records[0].tipo);
                        CambiarRfcp (records[0].rfc);
                        cambiarEstadop (records[0].estado);
                        cambiarSolicitat(records[0].solicita_traslado);
                        const pasajerodir = records[0].direcciones
                        if (pasajerodir !== undefined){
                        if (Object.keys(pasajerodir).length>0){
                        const direccion = Object.keys(pasajerodir).map(function (key) {return {id : key, ...pasajerodir[key]};});
                        Cambiardireccionlista (direccion);
                    }}
                        cambiarformulariopasajeroo(false);
                        cambiarformulariopasajero (false);
                        console.log(direccionlista)
                        }

// Accion si cliente no existe

                        else{
                            Swal.fire({
                                title: 'Resultado de busqueda',
                                text: 'El número telefónico no está registrado',
                                icon: 'warning',
                                timer:2000
                                })
                            Cambiarnombrep ('');
                            Cambiartelefonop ('');
                            Cambiarempresap ('');
                            CambiarTipop('');
                            CambiarRfcp('');
                            CambiarIdp('');
                            cambiarEstadop('');
                            cambiarSolicitat('');
                            cambiarformulariopasajero (true);
                            cambiarformulariopasajeroo(true);
                        }
                     })
          }
        
        
        }

    const onClickEliminaDireccion = async (e) => {
       e.preventDefault();
       var salir = false
            await Swal.fire({
                title: 'Advertencia',
                text: '¿Desea eliminar la direccion frecuente del cliente?',
                icon: 'warning',
                showDenyButton: true,
                denyButtonText: 'No',
                confirmButtonText: 'Si',
                confirmButtonColor: "blue"
                }).then(response => {
                    if(response.isDenied)
                    {salir = true
                    }
                } 
                )
            if(salir===true){return;}
            else{
                Cambiardireccionlista(direccionlista.filter((Idp) => Idp !== e.target.value))
                if (e.target.value !== '' && Idp !== '' ){
                    remove(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/pasajeros/${Idp}/direcciones/${e.target.value}`))
                }
                }    
            }



    return (  
        <Formulario onSubmit={handleSubmit}>
            <ContenedorDoble>
                <main>
                <ContenedorSubtitulo><Subtitulo>Pasajero a Editar</Subtitulo></ContenedorSubtitulo>    
                <ContenedorFiltros>
                <ContenedorInputconLabel><p>Buscar Telefono</p><Input name="telefonopb" type="text" placeholder="Telefono Pasajero" value={telefonopb} onChange={handleChange}/></ContenedorInputconLabel>
                    <Btn onClick={onClicktelefonopb}><Icono/></Btn>
                </ContenedorFiltros>

            {/* formulario Pasajero existente}*/}
                <div hidden={formulariopasajero}>

                {!(estadop === undefined || estadop === '') 
                    ? <ContenedorInputconLabel><p>Estado</p><SelectEstadoPasajero estadop={estadop} cambiarEstadop={cambiarEstadop}/></ContenedorInputconLabel>
                    : <></>
                }
                <ContenedorInputconLabel><p>Nombre</p><Input name="nombre" type="text" placeholder="Nombre" value={nombrep} onChange={handleChange}/></ContenedorInputconLabel>    
                <ContenedorInputconLabel><p>Telefono</p><Input name="telefono" type="text" placeholder="Telefono" value={telefonop} disabled = {true}/></ContenedorInputconLabel>   
                <ContenedorInputconLabel><p>RUT / Centro de Costo</p><Input name="rfc" type="text" placeholder="RUT / Centro de Costo" value={rfcp} onChange={handleChange}/></ContenedorInputconLabel>      
                <ContenedorInputconLabel><p>Cliente</p><SelectClientes cliente={empresap} cambiarCliente={Cambiarempresap}/></ContenedorInputconLabel> 
                <ContenedorInputconLabel><p>Tipo Pasajero</p><SelectTipoPasajero Tipop={Tipop} CambiarTipop={CambiarTipop}/></ContenedorInputconLabel>
                {!(estadop === undefined || estadop === '') 
                    ? <ContenedorInputconLabel><p>Puede Solicitar Traslado</p><SelectSolicitaTraslado solicitat={solicitat} cambiarSolicitat={cambiarSolicitat}/></ContenedorInputconLabel>
                    : <></>
                }
                
             {/*   <ContenedorFiltros><Input name="comentariop" type="text" placeholder="Comentario traslado Pasajero" value={comentariop} onChange={handleChange}/></ContenedorFiltros>  */}
            {/* Boton Pasajero Existente}*/}
                <ContenedorBoton >
                        <Boton as="button" primario conIcono type="submit"> Editar &nbsp;&nbsp;<IconoPlus/></Boton>
                </ContenedorBoton> 
                </div>

            </main>

            <aside>
             {/* Direcciones Frecuentes}*/}
                <div hidden={formulariopasajerodo}>    
                <div>
                    <ContenedorSubtituloPequeño> <Subtitulo>Eliminar Direccion Frecuente</Subtitulo></ContenedorSubtituloPequeño>
                </div>
                <Lista>
                    {direccionlista.map((direccionl) => {
                    return(  
                        <ElementoListad key={direccionl.id} >        
                            <ContenedorBotonesl >
                                <BotonAccion name="seleciona_origen" value={direccionl.id} onClick={onClickEliminaDireccion}/>
                                <Descripcion >{direccionl.Direccion} </Descripcion>
                            </ContenedorBotonesl>
                        </ElementoListad>
                            )
                    })}
                    </Lista>
                </div>
            </aside>

            </ContenedorDoble>
        </Formulario>
    );
}

export default FormularioEditaPasajero;